import { buildRichTooltip, tooltipField } from "../rich-tooltips"

type AppointmentContactSummary = {
  contactName?: string | null
  contactPhone?: string | null
  contactEmail?: string | null
}

export const buildOrderSummaryTooltip = ({
  orderTypeLabels,
  visibleOrderTypeLabel,
  dueStatus,
}: {
  orderNumberLabel: string
  /** Ordered internal labels, one entry per order type of the work order. */
  orderTypeLabels: readonly string[]
  visibleOrderTypeLabel?: string
  dueLabel?: string | null
  dueStatus?: string | null
  appointmentLabel?: string | null
  employeeLabel?: string | null
  appointmentContact?: AppointmentContactSummary | null
}) => {
  const isPlural = orderTypeLabels.length > 1
  const isTruncated = Boolean(
    orderTypeLabels.length === 1 &&
      visibleOrderTypeLabel &&
      visibleOrderTypeLabel !== orderTypeLabels[0],
  )

  return buildRichTooltip([
    isPlural ? tooltipField("Auftragstypen", orderTypeLabels.join(", ")) : null,
    isTruncated ? tooltipField("Auftragstyp", orderTypeLabels[0]) : null,
    dueStatus ? tooltipField("Frist", dueStatus) : null,
  ])
}
